import {FACIAL_BIOMETRIC_FEATURE_BY_HOST} from 'presentation/constants/facialBiometricFeatureByHost';
import {useHostName} from 'presentation/hooks';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';

export const useFacialBiometricFeatureFlag = () => {
	const {
		dataHostNameState: {product},
	} = useHostName();

	const {isEnabled} = useFeatureFlag(FACIAL_BIOMETRIC_FEATURE_BY_HOST[product]);

	return {
		isEnabled,
	};
};
